/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { ChildSubCategoryDtoName } from './childSubCategoryDtoName';
import type { ChildSubCategoryDtoCategoryOfTest } from './childSubCategoryDtoCategoryOfTest';

export interface ChildSubCategoryDto {
  /** Sub category code */
  code: string;
  /** Sub category name (multilingual) */
  name: ChildSubCategoryDtoName;
  /** Category of test */
  categoryOfTest: ChildSubCategoryDtoCategoryOfTest;
}
